import AppConfig from '@/AppConfig';
import { useEffect } from 'react';

interface IOptions {
  onBackPress: () => void;
  isWebView: boolean;
}

const useMobileBackPress = ({ onBackPress, isWebView }: IOptions) => {
  useEffect(() => {
    if (isWebView) {
      window.addEventListener(AppConfig.MOBILE_BACK_PRESS_EVENT, onBackPress);

      return () => {
        window.removeEventListener(
          AppConfig.MOBILE_BACK_PRESS_EVENT,
          onBackPress,
        );
      };
    }
  }, [isWebView, onBackPress]);
};

export default useMobileBackPress;
